import { render } from "./lead-reports.vue?vue&type=template&id=52a69dcc"
import script from "./lead-reports.vue?vue&type=script&lang=js"
export * from "./lead-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__